import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { isPublicUrl } from './auth.config';

/**
 * Guard que exige autenticação para todas as rotas, exceto as listadas em PUBLIC_ROUTES (auth.config.ts).
 * Redireciona para /login com returnUrl quando o usuário não está autenticado.
 */
export const authGuard: CanActivateFn = (_, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const url = state.url;

  if (isPublicUrl(url)) {
    return true;
  }

  if (auth.isLoggedIn()) {
    return true;
  }

  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: url },
  });
};
